// Custom
export { ReactComponent as User } from '../../../shared/assets/icons/user.svg';
export { ReactComponent as Leaf } from '../../../shared/assets/icons/dcs-pim-persona.svg';
export { ReactComponent as Bot } from '../../../shared/assets/icons/bot-default.svg';
export { ReactComponent as Bolt } from '../../../shared/assets/icons/bolt.svg';
export { ReactComponent as InstantMix } from '../../../shared/assets/icons/instant_mix.svg';
export { ReactComponent as Robot } from '../../../shared/assets/icons/robot.svg';
export { ReactComponent as Storefront } from '../../../shared/assets/icons/storefront.svg';
export { ReactComponent as Procurement } from '../../../shared/assets/icons/storefront.svg';
export { ReactComponent as Monitoring } from '../../../shared/assets/icons/monitoring.svg';
export { ReactComponent as NetworkIntelNode } from '../../../shared/assets/icons/network-intel-node.svg';
export { ReactComponent as LeftPanelOpen } from '../../../shared/assets/icons/left_panel_open.svg';
export { ReactComponent as LeftPanelClose } from '../../../shared/assets/icons/left_panel_close.svg';
export { ReactComponent as RightPanelOpen } from '../../../shared/assets/icons/right_panel_open.svg';
export { ReactComponent as RightPanelClose } from '../../../shared/assets/icons/right_panel_close.svg';
export { ReactComponent as Databricks } from '../../../shared/assets/icons/databricks.svg';
export { ReactComponent as Openai } from '../../../shared/assets/icons/openai.svg';
export { ReactComponent as Gemini } from '../../../shared/assets/icons/gemini.svg';
export { ReactComponent as Anthropic } from '../../../shared/assets/icons/anthropic.svg';
export { ReactComponent as DeepSeek } from '../../../shared/assets/icons/deepseek.svg';
export { ReactComponent as AzureAiServices } from '../../../shared/assets/icons/azureai.svg';
export { ReactComponent as EditPen } from '../../../shared/assets/icons/edit_pen.svg';
export { ReactComponent as Alnette } from '../../../shared/assets/icons/alnette.svg';


export enum SvgIcons {
    User = 'User',
    PimPersona = 'Leaf',
    Bot = 'Bot',
    Bolt = 'Bolt',
    InstantMix = 'InstantMix',
    Robot = 'Robot',
    Storefront = 'Storefront',
    NetworkIntelNode = 'NetworkIntelNode',
    Monitoring = 'Monitoring',
    LeftPanelOpen = 'LeftPanelOpen',
    LeftPanelClose = 'LeftPanelClose',
    RightPanelOpen = 'RightPanelOpen',
    RightPanelClose = 'RightPanelClose',
    Databricks = "Databricks",
    Openai = "Openai",
    Gemini = "Gemini",
    Anthropic = "Anthropic",
    DeepSeek = "DeepSeek",
    Alnette = "Alnette",
    AzureAiServices = "AzureAiServices",
    EditPen = "EditPen",
}
